import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import translate from 'angular-translate';
import translateStaticLoader from "angular-translate-loader-static-files";
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import ngResource from 'angular-resource';
import offClick from './chaps/offClick-loader';

angular.module('app', [
    uiRouter,
    uiBootstrap,
    translate,
    translateStaticLoader,
    Common,
    Components,
    ngResource,
    offClick
  ])

  .constant("LANGUAGES",
    [
      'es-ES',
      'en-GB'
    ])

  .config(($locationProvider, $translateProvider, $urlRouterProvider) => {
    "ngInject";
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');

    $urlRouterProvider.otherwise('/home');

    $translateProvider.useStaticFilesLoader({
      prefix: 'app/assets/translations/locale-',
      suffix: '.json'
    });

    $translateProvider.fallbackLanguage('en-GB');
    $translateProvider.use('en-GB');
    $translateProvider.useSanitizeValueStrategy(null);


  })
  // Patch related with: https://github.com/oauthjs/angular-oauth2/issues/32
  .config(($httpProvider) => {
    'ngInject';

    function authInterceptor($q, $rootScope) {
      return {
        responseError: function (rejection) {
          if (401 === rejection.status && rejection.data && 'invalid_grant' === rejection.data.error) {
            $rootScope.$emit('oauth:error', rejection);
          }
          return $q.reject(rejection);
        }
      };
    }

    authInterceptor.$inject = ['$q', '$rootScope'];

    $httpProvider.interceptors.push(authInterceptor);
  })
  .run(($state) => {
    "ngInject";
    //TODO Review run state on page load
    $state.go('home');
  })

  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js